import Container = Phaser.GameObjects.Container;
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Keys} from "@/constants/key";
import {ResourceType, SkillType} from "@/store/place/types";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import ResourceUtils from "@/utils/resource-utils";

export class ResourceAddEffectPanel extends Container {

    constructor(scene: Scene, x: number, y: number, skillDeltaText: string, resourceType: ResourceType, depth: number, toAlpha: number,
                xFrom: number, xTo: number, xAbsDelta: number, callback: () => unknown, preview: boolean = false, dead: boolean = false) {
        super(scene);

        this.setDepth(depth);

        let atlas = ResourceUtils.getResourceAtlasUi2(resourceType);
        let image = ResourceUtils.getResourceImageUi2(resourceType);
        let icon = SpriteUtils.addImage(this.scene, x + this.getOffsetX(resourceType, xAbsDelta)!- xFrom, y ,
            atlas ? atlas : image, atlas ? image : undefined);

        let damageText = TextUtils.addText(this.scene, skillDeltaText, icon.x / CU.S, icon.y / CU.S, '#ffffff',
            ResourceAddEffectPanel.getTextSize(skillDeltaText), 'bold', 70);

        this.add([icon, damageText]);
        if (dead) {
            let skeleton = SpriteUtils.addImage(this.scene, icon.x, icon.y - 40, Keys.IMG_SKULL_ICON, undefined, 0.5);
            this.add(skeleton);
        }
        let self = this;

        if (preview) {
            this.y = this.y - 36;
            this.setAlpha(0.01);
            this.scene.tweens.add({
                targets: self,
                props: {
                    alpha: {value: 1.0, duration: 2700, ease: 'Linear'}
                }
            });
        } else {
            this.scene.tweens.add({
                targets: [icon, damageText],
                duration: 1700,
                props: {
                    y: {value: (y + xTo) * CU.S, ease: 'Linear'},
                    // x: {value: (x - xTo) * CU.S, ease: 'Linear'},
                    alpha: {value: toAlpha, duration: 1700, ease: 'Linear'}
                },

                onComplete() {
                    callback();
                }
            });
        }
    }

    private static getTextSize(skillDeltaText: string) {
        if (skillDeltaText.length <= 2) {
            return 18;
        } else if (skillDeltaText.length <= 3) {
            return 17;
        } else if (skillDeltaText.length <= 4) {
            return 16;
        } else if (skillDeltaText.length <= 5) {
            return 15;
        }
        return 14;
    }

    private chooseIcon(resourceType: ResourceType) {
        return ResourceUtils.getResourceImageId(resourceType);
        // switch (resourceType) {
        //     case ResourceType.GOLD:
        //         return Keys.UI_DAMAGE_HEARTH;
        //     case SkillType.DEFENCE:
        //         return Keys.UI_DAMAGE_SHIELD;
        //     case SkillType.ATTACK:
        //         return Keys.UI_DAMAGE_SWORD;
        // }
    }

    private getOffsetX(resourceType: ResourceType, absDelta: number) {
        return 0;
        // switch (resourceType) {
        //     case SkillType.HEALTH:
        //         return 0;
        //     case SkillType.DEFENCE:
        //         return absDelta;
        //     case SkillType.ATTACK:
        //         return -absDelta;
        // }
    }

}
